<template>
  <div v-if="elementTypeQuestion == 'checkboxes'">
    <select id="select-options" v-model="question.maxchoice">
      <option value="0">Illimité</option>
      <option
        v-for="(answer, index) in question.answers.length"
        :key="index"
        :value="index+1"
      >{{index+1}}
      </option>
    </select>
    <span style="font-size:12px;"
      >{{ $t("question.choix.maxchoice") }} &nbsp;
    </span
    >
  </div>
</template>

<script>
export default {
  name: 'OptionCheckboxes',
  props: {
    question: Object,
    elementTypeQuestion: String
  }
}
</script>
<style scoped>
#select-options {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #ffffff;
  color:#aaa;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 50%;
  padding:6px;
  padding-right: 1.2rem;
   cursor:pointer;
   border:.8px solid #dddddd
}
select option{
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/OptionCheckboxes.vue